import { Component, ElementRef, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { AnalyticsService } from '../analytics.service';
import { Chart } from 'chart.js';
import { Router } from '@angular/router';

@Component({
  selector: 'analytic-dashboard',
  templateUrl: './analytic-dashboard.component.html',
  styleUrls: ['./analytic-dashboard.component.scss']
})
export class AnalyticDashboardComponent implements OnInit {

  @Input('type') analyticType: String
  @Input('timePeriod') fatigueTimePeriod: String
  @ViewChild('LineChartCanvas', { static: false }) private lineChartCanvas: ElementRef;
  analyticDashboardType: String
  protected lineChartObject: Chart;
  competencyDashboard
  _competencyType
  _assignedAndUnassigned
  _competencyStatus
  _categorywiseFilter
  _allCategory
  selectedType = 'all'
  selectedCategory = 'all'
  _compDrillDown
  _isDestroy = false
  loading = false
  breadCrumbList = []
  selectedIndex = 0
  fatigueDashboard
  _fatigueChartData
  timeperiodRange
  isReset
  constructor(
    private _router: Router,
    public _analyticService: AnalyticsService
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.analyticType && changes.analyticType.currentValue) this.analyticDashboardType = changes.analyticType.currentValue
    if (changes.fatigueTimePeriod && changes.fatigueTimePeriod.currentValue) this.timeperiodRange = changes.fatigueTimePeriod.currentValue
    this.getDashboardDetails()

  }


  // UTILITY


  selectCategoryType() {
    console.log("VALUE OF CURRENT TYPE", this.selectedType)
    this.getCompetencyDashboardDetails()
    this._isDestroy = true
  }

  selectCategory() {
    console.log("SELECTED CATEGORY DATA", this.selectedCategory)
    this.getCompetencyDashboardDetails()
    this._isDestroy = true
  }

  navigationPage(item) {
    console.log("NEW NAVIGATION ITEM", item)
    this._router.navigateByUrl(item.url)
  }



  getDashboardDetails() {
    if (this.analyticDashboardType === 'competency') {
      // this.breadCrumbList.push({ name: 'Dashboard', url: 'competency?type=dashboard' }, { name: 'List', url: 'competency?type=list' })
      this.getCompetencyDashboardDetails()
    }
    if (this.analyticDashboardType === 'fatigue') this.getFatigueDashboardDetails()
  }

  resetChart() {
    this.isReset = true
  }

  clickChart(event) {
    this.isReset = false
  }


  // API CALL





  // Get competency dashboard data 
  getCompetencyDashboardDetails() {
    this.loading = true
    let obj = {
      _competencyType: {
        value: this.selectedType
      },
      _assignedAndUnassigned: {
        value: this.selectedCategory
      }
    }
    this._analyticService.getCompetencyDashboardData(obj).subscribe((data) => {
      this.competencyDashboard = data
      console.log("COMPETENCY ANALYSIS DASHBOARD DATA", this.competencyDashboard)
      this._competencyType = this.competencyDashboard._competencyType
      this._assignedAndUnassigned = this.competencyDashboard._assignedAndUnassigned
      this._competencyStatus = this.competencyDashboard._competencyStatus
      this._categorywiseFilter = this.competencyDashboard._categorywiseFilter
      this._allCategory = this.competencyDashboard._allCategory
      this._compDrillDown = this.competencyDashboard._compDrillDown
      this._isDestroy = false
      this.isReset = false
      this.loading = false
    }, error => {
      console.log("ERRROR WHILE GET COMPETENCY DASHBOARD DETAILS", error)
    })


  }


  // Fatigue Dashboard Details
  getFatigueDashboardDetails() {
    this.loading = true
    console.log("THIS IS FOR FATIGUE ")
    let obj = {
      range: this.timeperiodRange
    }
    this._analyticService.getFatigueDashboardData(obj).subscribe((data) => {
      this.fatigueDashboard = data
      console.log("Fatigue Data", this.fatigueDashboard)
      this._fatigueChartData = this.fatigueDashboard.chartData
      this.loading = false
    }, error => {
      console.log("ERrror while get fatigue dashboard", error)
      this.loading = false
    })
  }

}
